module.exports = "th {\r\n  text-transform: uppercase;\r\n}\r\n\r\n.member-name {\r\n  color: cornflowerblue;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/clubprogram-reports/components/financials-report/financials-report.component.css
// module id = ./src/app/shared/clubprogram-reports/components/financials-report/financials-report.component.css
// module chunks = main